import { Paragraph, PrimaryFont, SecondaryFont } from '../../components/typographies';
import styled from 'styled-components';
import { ColorAddiBackgroundMedium, ColorAddiBackgroundSoft, ColorAddiCompFiveLighten4, ColorAddiFontAction, ColorAddiFontHint, ColorAddiFontPrimary, ColorAddiFontSecondary, ColorAddiFontSuccess, ColorAddiWhite, } from '@addi/foundation/dist/web/colors';
import { FontAddiWeightSemiBold } from '@addi/foundation/dist/web/fonts';
export const PaymentInstallmentTooltipBox = styled.div `
  ${SecondaryFont}
  text-align: center;
  font-size: 0.9rem;
  line-height: 148%;

  visibility: ${({ isOpen }) => (isOpen ? 'visible' : 'hidden')};
  position: absolute;
  bottom: calc(100% + 10px);
  right: -85px;
  border-radius: 8px;
  background-color: ${ColorAddiCompFiveLighten4};
  color: ${ColorAddiFontPrimary};
  width: 200px;
  padding: 8px;

  transition: visibility 0.5s, color 0.5s, background-color 0.5s, width 0.5s,
    padding 0.5s ease-in-out;

  &:before {
    content: '';
    width: 5px;
    height: 5px;
    left: 40px;
    bottom: -5px;
    position: absolute;
    border: 5px solid transparent;

    border-color: ${ColorAddiCompFiveLighten4} ${ColorAddiCompFiveLighten4} transparent transparent;
    transform: rotate(135deg);
    transition: border 0.3s ease-in-out;
  }
`;
export const PaymentInstallmentContainer = styled.div `
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: flex-start;
  padding: 12px 6px;

  position: static;
  min-width: 60px;
  height: 90px;
  left: 84px;
  top: 0px;

  background: ${({ isPaidOut }) => (isPaidOut ? ColorAddiBackgroundSoft : ColorAddiWhite)};
  border: 2px solid ${({ isActive }) => (isActive ? ColorAddiFontHint : ColorAddiBackgroundMedium)};
  border-radius: 4px;
`;
export const PaymentInstallmentIndex = styled.div ``;
export const PaymentInstallmentInfo = styled.div ``;
export const PaymentInstallmentNumber = styled.div `
  background: ${({ status }) => status === 'active' ? ColorAddiFontAction : ColorAddiCompFiveLighten4};
  & > span {
    color: ${({ status }) => (status === 'active' ? ColorAddiWhite : ColorAddiFontAction)};
    ${PrimaryFont}
    font-weight: 700;
    font-size: 0.875rem;
    line-height: 100%;
  }
  border-radius: 50%;
  padding: 0 5px;
`;
export const PaymentInstallmentInfoDate = styled(Paragraph) `
    color: ${({ isPaidOut }) => (isPaidOut ? ColorAddiFontSuccess : ColorAddiFontPrimary)};
    margin 0 auto;
    font-size: 0.875rem;
    font-weight: ${FontAddiWeightSemiBold};
`;
export const PaymentInstallmentInfoAmount = styled(Paragraph) `
    color: ${({ isPaidOut }) => (isPaidOut ? ColorAddiFontSecondary : ColorAddiFontPrimary)};
    margin 0 auto;
    font-size: 0.75rem;
    font-weight: ${FontAddiWeightSemiBold};
`;
export const TooltipCard = styled.div `
  position: relative;
  width: 100%;
`;
//# sourceMappingURL=payment-installment.styled.js.map